import TeamDetail from './TeamDetail';

export default TeamDetail;
